
import { useAtom } from "jotai";
import { X } from "lucide-react";
import { FC } from "react";
import style from "./style.module.css";
import { planTableSelectedPlanAtom } from "@utils/store/store";
import { BatchPlan, POP_UP_ACTION } from "@components/Sales/batch.type";

interface props {
  onClose: (clickFrom?: string, plan?: any) => void;
  batchName: string;
  triggerEvent: (actionType: POP_UP_ACTION) => void;
}
const TableHeader: FC<props> = ({ onClose, batchName, triggerEvent }) => {
  const [selectedPlan] = useAtom(planTableSelectedPlanAtom);
  const [_, setSelectedPlan] = useAtom(planTableSelectedPlanAtom);

  const handleOnClose = () => {
    triggerEvent(POP_UP_ACTION.POP_UP_CLOSE);
    onClose('close_icon', {});
    setSelectedPlan({} as BatchPlan);
  };
  return (
    <section className={style.header}>
      <span>{batchName || ""}</span>
      {selectedPlan?._id && (
        <span className={style.closeIcon} onClick={handleOnClose}>
          <X size={20} />
        </span>
      )}
    </section>
  );
};

export default TableHeader;
